import { render, staticRenderFns } from "./CreatePostOptions.vue?vue&type=template&id=bc4b7002&"
import script from "./CreatePostOptions.vue?vue&type=script&lang=js&"
export * from "./CreatePostOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports